<template>
  <div class="rmaForm">
    <p id="headertext">
      <span v-html="$mlGet('rmaConfirm1-header')"></span>
    </p>
    <div class="input-container">
      <label for="input-clientReference">
        {{ $mlGet("rmaConfirm1-input-clientReference") }}
      </label>
      <input
        name="clientReference"
        type="text"
        v-model="$store.state.rma.clientReference"
        id="input-clientReference"
      />

      <label for="input-externalReference">
        {{ $mlGet("rmaConfirm1-input-externalReference") }}
      </label>
      <input
        name="externalReference"
        type="text"
        v-model="$store.state.rma.externalReference"
        id="input-externalReference"
      />
    </div>
    <div class="information-box">
      <span v-html="$mlGet('rmaConfirm1-informationBox')"></span>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

import { highlightElementQuerySelector } from "@/helpers/alerts";
import { PageChangeContext, PageName } from "@/views/CreateRma.vue";

@Component({})
export default class RmaConfirm1 extends Vue {
  public async beforePageLeave(context: PageChangeContext): Promise<boolean> {
    if (context.isReturnOperation) return true;

    if (
      this.$store.getters.getIsDealer === true &&
      this.$store.state.rma.clientReference == ""
    ) {
      highlightElementQuerySelector("#input-clientReference");
      return false;
    }
    return true;
  }

  public async afterPageEnter(context: PageChangeContext): Promise<void> {
    return;
  }

  public async onPageLeave(context: PageChangeContext): Promise<PageName> {
    return "RmaConfirmation";
  }
}
</script>

<style scoped>
* {
  text-align: left;
}

#rmaClientReference-wrapper {
  padding: 2ex 0;
}

.input-container {
  display: grid;
  grid-template-columns: 35ex 30ex;
}

.input-container input {
  border: 1px solid lightgray;
  box-sizing: border-box;
  padding: 5px;
  margin: 4px 0;
  width: 100%;
  font-size: 100%;
}

.input-container label {
  margin: 7px 0 0 0;
  font-size: 100%;
}

#headertext {
  padding: 0;
  margin: 0 0 2ex 0;
}
</style>
